import Link from "next/link";

import {
  ContactEmailIcon,
  ContactLocationIcon,
  ContactPhoneIcon,
} from "@/components/data-display/icon";
import SocialMediaLink from "@/components/layout/footer/top/socialMediaLink";
import { RobodocInfo } from "@/utils/constants/robodoc-info.constants";

function ContactInformation() {
  return (
    <div className="flex w-full flex-col gap-[1.938rem] overflow-hidden rounded-[12px] bg-[#FAFBFC] px-[1.25rem] pb-[2rem] text-[0.938rem] leading-[1.5rem] opacity-100 md:h-[33.75rem] md:w-[22.5rem]">
      <div className="mt-[1.5rem] flex flex-col gap-[1rem]">
        <h1 className="text-[1rem] font-bold">Contact Information</h1>
        <p> You are welcome at any time. It will be pleasure to serve you</p>
      </div>
      <div className="flex items-start gap-[1rem]">
        <ContactLocationIcon className="mt-[0.4rem] " />
        <div className="w-[90%] sm:w-[70%]">{RobodocInfo.officeAddress}</div>
      </div>
      <div className="flex items-start gap-[1rem]">
        <ContactPhoneIcon className="mt-[0.2rem] text-green-500" />
        <Link href={"tel:" + RobodocInfo.phone1}>{RobodocInfo.phone1}</Link>
      </div>
      <div className="flex items-start gap-[1rem]">
        <div>
          <ContactEmailIcon className="mt-[0.5rem] " />
        </div>
        <div className="flex flex-col">
          <Link href={"mailto:" + RobodocInfo.email1}>
            {RobodocInfo.email1}
          </Link>
          <Link href={"mailto:" + RobodocInfo.email2}>
            {RobodocInfo.email2}
          </Link>
        </div>
      </div>
      <div className="mt-[0.7rem] px-2">
        <SocialMediaLink />
      </div>
    </div>
  );
}

export default ContactInformation;
